module.exports = __webpack_public_path__ + "h5/img/uploadTip.45de64a2.png";